import { fillVars, longDate } from "@/lib/letters";

export const footerLines = (c) => [
  [c.address, c.phone && `Tél. ${c.phone}`, c.email, c.website].filter(Boolean).join(" · "),
  [c.raison_sociale, c.rccm && `RCCM ${c.rccm}`, c.nif && `NIF ${c.nif}`].filter(Boolean).join(" · "),
  c.bank_details, c.legal_mentions, c.footer_text,
].filter(Boolean).map((s) => s.replace(/\s*\n\s*/g, " · "));

export function LetterHeader({ company: c }) {
  return (
    <div style={{ width: 794, padding: "34px 68px 14px", boxSizing: "border-box", fontFamily: "Arial, sans-serif", background: "#fff" }}>
      <div style={{ display: "flex", alignItems: "center", justifyContent: "space-between", gap: 16, borderBottom: "3px solid #076633", paddingBottom: 12 }}>
        {c.logo_url ? <img src={c.logo_url} alt="" crossOrigin="anonymous" style={{ maxHeight: 64, maxWidth: 210, objectFit: "contain" }} />
          : <div style={{ fontSize: 24, fontWeight: 800, color: "#076633" }}>{c.name || "OMNIBAT"}</div>}
        <div style={{ textAlign: "right", fontSize: 10.5, color: "#334155", lineHeight: 1.45 }}>
          <div style={{ fontSize: 14, fontWeight: 700, color: "#076633" }}>{c.name}</div>
          {c.raison_sociale && <div>{c.raison_sociale}</div>}
          {c.address && <div style={{ whiteSpace: "pre-line" }}>{c.address}</div>}
          <div>{[c.phone, c.email].filter(Boolean).join(" · ")}</div>
          {c.website && <div>{c.website}</div>}
          {c.extra_header && <div>{c.extra_header}</div>}
        </div>
      </div>
    </div>
  );
}

// Corps du courrier tel qu'il sera imprimé (largeur utile A4 = 658 px)
export function LetterBody({ letter: l, cfg, signatory: s, company: c, qr }) {
  const html = fillVars(l.contenu_html, l, cfg);
  const lieu = l.lieu || cfg?.lieu || "";
  return (
    <div style={{ width: 658, fontFamily: "Times New Roman, serif", fontSize: "12pt", color: "#0f172a", background: "#fff", lineHeight: 1.4 }}>
      <div className="keep" style={{ display: "flex", justifyContent: "space-between", fontSize: "10.5pt" }}>
        <div>
          <div><b>Réf. :</b> {l.reference || "(attribuée à l'enregistrement)"}</div>
          {l.ref_precedente && <div><b>V/Réf. :</b> {l.ref_precedente}</div>}
        </div>
        <div>{lieu ? `${lieu}, le ` : "Le "}{longDate(l.date)}</div>
      </div>
      <div className="keep" style={{ marginLeft: "52%", marginTop: 26, fontSize: "11.5pt" }}>
        {l.destinataire && <div style={{ fontWeight: 700 }}>{l.destinataire}</div>}
        {l.destinataire_fonction && <div>{l.destinataire_fonction}</div>}
        {l.entreprise && <div style={{ fontWeight: 700 }}>{l.entreprise}</div>}
        {l.adresse && <div style={{ whiteSpace: "pre-line" }}>{l.adresse}</div>}
      </div>
      <p style={{ marginTop: 30 }}><b><u>Objet</u> : {fillVars(l.objet, l, cfg).replace(/&amp;/g, "&")}</b></p>
      <div className="letter-content" dangerouslySetInnerHTML={{ __html: html }} />
      <div className="keep" style={{ marginTop: 28, marginLeft: "52%", textAlign: "center", position: "relative", minHeight: 120 }}>
        <div style={{ fontWeight: 700 }}>{s?.fonction || l.expediteur_fonction}</div>
        <div style={{ height: 80, position: "relative" }}>
          {s?.signature_url && (l.esign || !s.user_id) && <img src={s.signature_url} alt="" style={{ maxHeight: 78, maxWidth: 200, position: "relative", zIndex: 2 }} />}
          {l.avec_cachet && (s?.cachet_url || c.cachet) && <img src={s?.cachet_url || c.cachet} alt="" style={{ maxHeight: 96, position: "absolute", left: "8%", top: -6, opacity: 0.85 }} />}
        </div>
        <div style={{ fontWeight: 700 }}>{s?.nom || l.expediteur}</div>
        {l.esign && <div style={{ fontSize: "7.5pt", color: "#475569", marginTop: 4, fontFamily: "Arial" }}>Signé électroniquement le {new Date(l.esign.at).toLocaleString("fr-FR")}<br />Code de vérification : {l.esign.code}</div>}
        {l.esign && qr && (
          <div style={{ position: "absolute", left: "-62%", top: 6, display: "flex", alignItems: "center", gap: 8, fontFamily: "Arial", textAlign: "left" }}>
            <img src={qr} alt="" style={{ width: 78, height: 78 }} />
            <div style={{ fontSize: "7pt", color: "#475569", width: 130, lineHeight: 1.3 }}>Scannez pour vérifier l'authenticité de ce document<br /><b>{window.location.host}/verifier</b></div>
          </div>
        )}
      </div>
      {(l.attachments || []).length > 0 && (
        <div className="keep" style={{ marginTop: 18, fontSize: "10pt" }}>
          <b><u>P.J.</u> :</b> {(l.attachments || []).map((a) => a.nom).join(" ; ")}
        </div>
      )}
    </div>
  );
}
